webpackJsonp([176098834507362],{

/***/ 606:
/***/ (function(module, exports) {

	module.exports = ["/images/gallery/relax1.jpg","/images/gallery/relax2.jpg","/images/gallery/relax3.jpg","/images/gallery/work1.jpeg","/images/gallery/work2.jpeg","/images/gallery/work3.jpeg","/images/gallery/relax4.jpg","/images/gallery/relax5.jpg","/images/gallery/relax6.jpg","/images/gallery/work4.jpeg","/images/gallery/work5.jpeg","/images/gallery/work6.jpg","/images/gallery/relax8.jpg","/images/gallery/relax9.jpg","/images/gallery/relax7.jpg","/images/gallery/work7.jpg","/images/gallery/work8.jpg","/images/gallery/work9.jpg"]

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactJss = __webpack_require__(6);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dots = __webpack_require__(22);
	
	var _dots2 = _interopRequireDefault(_dots);
	
	var _gallery = __webpack_require__(606);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _components = __webpack_require__(17);
	
	var _containers = __webpack_require__(23);
	
	var _tools = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validator = (0, _tools.createValidator)({
	  name: {
	    presence: { message: 'Name field is required.' },
	    length: { minimum: 2, maximum: 256, message: 'A valid name is required.' }
	  },
	  company: {
	    presence: { message: 'Company name field is required.' },
	    length: {
	      minimum: 2,
	      maximum: 256,
	      message: 'A valid company name is required.'
	    }
	  },
	  email: {
	    email: { message: 'A valid email address is required.' }
	  },
	  phone: {
	    length: {
	      maximum: 32,
	      message: 'A valid phone number is required.'
	    }
	  },
	  tech: {
	    presence: { message: 'This field is required.' },
	    length: {
	      minimum: 2,
	      maximum: 2048,
	      message: 'A valid message is required.'
	    }
	  },
	  companySize: {
	    presence: { message: 'The company size field is required.' },
	    length: {
	      minimum: 2,
	      maximum: 2048,
	      message: 'A valid company size is required.'
	    }
	  },
	  location: {
	    presence: { message: 'The location field is required.' },
	    length: {
	      minimum: 2,
	      maximum: 2048,
	      message: 'A valid location is required.'
	    }
	  },
	  notes: {
	    presence: { message: 'The notes field is required.' },
	    length: {
	      minimum: 2,
	      maximum: 2048,
	      message: 'Valid notes are required.'
	    }
	  }
	});
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      minHeight: '100vh',
	      flexDirection: 'column'
	    },
	
	    // MAIN
	    main: {
	      flex: '1',
	      '& h1': {
	        marginTop: 0
	      }
	    },
	    mainContainer: {},
	    mainItems: {
	      padding: 0,
	      margin: 0
	    },
	    mainContent: {
	      padding: 20,
	      maxWidth: '100%'
	    },
	
	    // FORM
	    form: {
	      marginTop: 60
	    },
	    formInput: {
	      marginBottom: 20
	    },
	    formInputQuestion: {
	      minHeight: 90
	    },
	    formInputMessage: {
	      borderBottomWidth: 0,
	      minHeight: 180
	    },
	
	    // GALLERY
	    gallery: {
	      marginTop: 20,
	      padding: 0
	    },
	
	    // FOOTER
	    footer: {
	      backgroundColor: theme.palette.inverted.base,
	      backgroundImage: 'url(' + _dots2.default + ')',
	      position: 'relative',
	      marginTop: 0
	    },
	    footerDrops: {
	      display: 'none'
	    },
	
	    // small +
	    '@media screen and (min-width: 48em)': {
	      // MAIN
	      mainContainer: {
	        padding: [120, 20, 20]
	      },
	      mainContent: {
	        padding: 0,
	        maxWidth: 550
	      },
	
	      // FORM
	      form: {
	        marginTop: 80
	      },
	
	      // GALLERY
	      gallery: {
	        marginTop: 0
	      },
	
	      // FOOTER
	      footer: {
	        marginTop: 80
	      },
	      footerDrops: {
	        display: 'block'
	      }
	    }
	  };
	};
	
	var EngineeringRetreatsPage = function (_React$Component) {
	  _inherits(EngineeringRetreatsPage, _React$Component);
	
	  function EngineeringRetreatsPage() {
	    _classCallCheck(this, EngineeringRetreatsPage);
	
	    // Initialize form fields as empty.
	    var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	    _this.onUpdate = function (data, callback) {
	      _this.setState({ data: data }, callback);
	    };
	
	    _this.onSubmit = function (ev) {
	      var formHasErrors = _this.validation.getValidityForm();
	      if (formHasErrors) {
	        ev.preventDefault();
	        _this.validation.validate();
	        return;
	      }
	    };
	
	    var fields = {};
	    Object.keys(validator.constraints).forEach(function (key) {
	      return fields[key] = '';
	    });
	
	    _this.state = {
	      data: {
	        dirties: {},
	        changed: {},
	        errors: {},
	        fields: fields
	      }
	    };
	
	    // Validation form ref.
	    _this.validation = null;
	    return _this;
	  }
	
	  EngineeringRetreatsPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var classes = this.props.classes;
	    var data = this.state.data;
	
	    // Make validated and controlled dynamic fields.
	
	    var makeField = function makeField(name, props) {
	      return _react2.default.createElement(_components.TextField, _extends({}, props, {
	        name: name,
	        errorText: data.errors[name],
	        value: data.fields[name],
	        onChange: function onChange(ev) {
	          return _this2.validation.onChange(name, ev.target.value);
	        },
	        onBlur: function onBlur() {
	          return _this2.validation.onBlur(name);
	        }
	      }));
	    };
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Engineering Retreats | Real World React'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.root },
	        _react2.default.createElement(_components.Header, null),
	        _react2.default.createElement(
	          'div',
	          { className: classes.main },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(classes.mainContainer, 'container') },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(classes.mainItems, 'row') },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-8' },
	                _react2.default.createElement(
	                  'div',
	                  { className: classes.mainContent },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      'Offsite Retreats to'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'text-inverted background-secondary' },
	                      '\xA0Supercharge your Engineers\xA0'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'If you think that retreats are only for senior management, or you just don\u2019t believe that they provide demonstrable value, then you haven\u2019t heard of React Retreat.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'With React Retreat, we seamlessly blend our training and consulting services with outings and activities to not only solve your technical problems and train your team, but also to bring your team closer together. That way your engineers can level up their skills while forging a bond with their colleagues and managers.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Experience the most productive fun you\u2019ve ever had with React Retreat.'
	                  ),
	                  _react2.default.createElement(
	                    'form',
	                    {
	                      className: classes.form,
	                      onSubmit: this.onSubmit,
	                      noValidate: true,
	                      name: 'engineering-retreats',
	                      method: 'POST',
	                      'data-netlify': 'true'
	                    },
	                    _react2.default.createElement(
	                      _components.Validation,
	                      {
	                        ref: function ref(el) {
	                          return _this2.validation = el;
	                        },
	                        data: data,
	                        validator: validator,
	                        onUpdate: this.onUpdate
	                      },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Tell us about your',
	                        ' ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'text-inverted background-secondary' },
	                          '\xA0Dream Retreat\xA0'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: (0, _classnames2.default)(classes.formInput, 'col-sm-6 col-xs-12')
	                          },
	                          makeField('name', { placeholder: 'Name*' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: (0, _classnames2.default)(classes.formInput, 'col-sm-6 col-xs-12')
	                          },
	                          makeField('email', {
	                            type: 'email',
	                            placeholder: 'Email*'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: (0, _classnames2.default)(classes.formInput, 'col-sm-6 col-xs-12')
	                          },
	                          makeField('company', { placeholder: 'Company*' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: (0, _classnames2.default)(classes.formInput, 'col-sm-6 col-xs-12')
	                          },
	                          makeField('phone', { placeholder: 'Phone' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: (0, _classnames2.default)(classes.formInput, 'col-xs-12') },
	                          makeField('tech', {
	                            isTextarea: true,
	                            placeholder: 'What technologies are you seeking to learn, or improve?*',
	                            fieldProps: {
	                              className: classes.formInputQuestion
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: (0, _classnames2.default)(classes.formInput, 'col-xs-12') },
	                          makeField('companySize', {
	                            isTextarea: true,
	                            placeholder: 'How big is your team?*',
	                            fieldProps: {
	                              className: classes.formInputQuestion
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: (0, _classnames2.default)(classes.formInput, 'col-xs-12') },
	                          makeField('location', {
	                            isTextarea: true,
	                            placeholder: 'Where would you like your retreat to be?*',
	                            fieldProps: {
	                              className: classes.formInputQuestion
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: (0, _classnames2.default)(classes.formInput, 'col-xs-12') },
	                          _react2.default.createElement(_components.TextField, {
	                            isTextarea: true,
	                            placeholder: 'Tell us more about what you\'re looking to learn from this Retreat*',
	                            fieldProps: {
	                              className: classes.formInputMessage
	                            },
	                            name: 'notes',
	                            value: data.fields.notes,
	                            onChange: function onChange(ev) {
	                              return _this2.validation.onChange('notes', ev.target.value);
	                            },
	                            onBlur: function onBlur() {
	                              return _this2.validation.onBlur('notes');
	                            }
	                          }),
	                          _react2.default.createElement(_components.Button, {
	                            showArrow: true,
	                            textAlign: 'left',
	                            palette: 'text',
	                            type: 'submit',
	                            children: 'Submit'
	                          }),
	                          !!data.errors.notes && _react2.default.createElement(
	                            _components.ErrorMsg,
	                            null,
	                            data.errors.notes
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(classes.gallery, 'col-xs-12 col-sm-4') },
	                _react2.default.createElement(_components.Gallery, { images: _gallery2.default })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.footer },
	          _react2.default.createElement(
	            'div',
	            { className: classes.footerDrops },
	            _react2.default.createElement(_components.Drops, { bottom: true })
	          ),
	          _react2.default.createElement(_components.Footer, { footerContent: _react2.default.createElement(_containers.SignUp, null) })
	        )
	      )
	    );
	  };
	
	  return EngineeringRetreatsPage;
	}(_react2.default.Component);
	
	exports.default = (0, _reactJss2.default)(styles)(EngineeringRetreatsPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-engineering-retreats-js-b525dc1a0f0161549bb5.js